import { CLabel } from '@coreui/react';
import * as React from 'react';
import SunEditor from 'suneditor-react';
import SetOptions from 'suneditor-react/dist/types/SetOptions';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import { IImageProvider } from '../../abstraction';
import { Utils } from '../../core/utils';


interface IControlHTMLModel {
	Class: string;
	Content: string;
	Description: string;
	InlineStyle: string;
	ShowHeader?: boolean;
	Key: string;
	ShowMoreIcon: string;
	Visible: boolean;
}

interface IProps {
	bsSize: string;
	imageProvider: IImageProvider;
	control: IControlHTMLModel;
	ShowMoreOnLoad: boolean;
}

interface IState {
	isOpen: boolean;
	showOnLoad: boolean;
	value: any;
}

export class KControlHTMLEditor extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);

		this.editor = React.createRef();
		
		this.state = {
			isOpen: false,
			showOnLoad: this.props.ShowMoreOnLoad,
			value: this.props.control.Content
		}
	}

	private editor: any;


	//#region Local events 

	//#endregion 

	//#region Rendus

	handleChange = (content) => {
		this.props.control.Content = content;
		this.setState({
			value: content
		});
		//this.props.onRichTextEditorChange(content);
	}

	render() {
		let ctrl = this.props.control;

		if (!ctrl.Visible) return null;

		let inlineStyle = Utils.decodeInlineStyleFromJson(ctrl.InlineStyle);

		let header = ctrl.ShowHeader == false ? "" : <CLabel htmlFor={ctrl.Key} >{ctrl.Description}</CLabel>;

		let a: SetOptions = {
			mode: "classic",	 
			"buttonList": [
				[
					"undo",
					"redo",
					"font",
					"fontSize",
					"formatBlock",
					"paragraphStyle",
					"blockquote",
					"bold",
					"underline",
					"italic",
					"strike",
					"fontColor",
					"hiliteColor",
					"outdent",
					"indent",
					"align",
					"horizontalRule",
					"list",
					"lineHeight",
					"table",
					//"link",
					//"image",
					//"print",
					"fullScreen"
				]
			],
		}

		return (
			<div className={`KControl KControlHTMLEditor ${ctrl.Class} ${this.props.bsSize}`} style={inlineStyle} >
				{header}
				<SunEditor setContents={this.state.value} onChange={this.handleChange} setOptions={a} defaultValue={""} />
			</div>
		)
	}
	//<CInput onClick={this.toggle} className="input" readOnly={true} type="textarea" name={ctrl.Key} color=" default" value={ctrl.Content} onDoubleClick={this.toggle} />
	//#endregion
}